// The owner's course walkthrough feedback tab (Nov 3 2026): shown on every page
// for her test learner, and for admins outside the admin pages. Saves to
// `feedback` with screenshots (see TesterFeedbackWidget courseReview).
import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import TesterFeedbackWidget from "./TesterFeedbackWidget";

const REVIEW_LEARNERS = ["SfXYMITYXVRkakPOaajHuk2WO7X2"]; // the owner's test learner

/** True for the owner's test learner (the learner side tab hides for them, owner Nov 3 2026). */
export const isReviewLearner = (uid) => REVIEW_LEARNERS.includes(uid);

export default function CourseReviewFeedback() {
  const { currentUser, isAdmin } = useAuth();
  const { pathname } = useLocation();
  const uid = currentUser?.uid;
  if (!uid) return null;
  const show = REVIEW_LEARNERS.includes(uid) || (isAdmin && !pathname.startsWith("/admin"));
  return show ? <TesterFeedbackWidget courseReview /> : null;
}
